<div class="pointer-events-none absolute right-5 top-5 z-10">
  <input tuiRadio type="radio" [checked]="selected()" [tabIndex]="-1" />
</div>
<ng-content />
